
import MUIDataTable from 'mui-datatables'
import { Link, withRouter } from 'react-router-dom';
import axiosInstance from '../../../axiosInstance';
import "../../../css/Users.css"
import { containsPermission, logOut } from '../../helper';
import React, {Component} from 'react';
import { Form, Col, ButtonToolbar, ButtonGroup, Button } from 'react-bootstrap';


const columns = [
    {
        "name" : "username",
        "label" : "სახელი",
        "options": {
            "sort" : true
        }
    },
    {
        "name" : "role",
        "label" : "როლი",
        "options": {
            "sort" : true
        }
    },
]
class Users extends Component {
    constructor(props){
        super(props);
        this.onRowsDelete = this.onRowsDelete.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
        this.toolbarSelect = this.toolbarSelect.bind(this);
        this.onRowSelectionChange = this.onRowSelectionChange.bind(this);
        this.state = {
            data:[],
            selected_user:-1,
            options:{
                filterType: 'checkbox',
                selectableRowsHeader:false,
                expandableRowsHeader:false,
                viewColumns:false,
                print:false,
                filter:false,
                selectableRows:'single',
                rowsSelected:[],
                onRowsDelete:this.onRowsDelete,
                onRowClick:this.onRowClick,
                customToolbarSelect:this.toolbarSelect,
                onRowSelectionChange:this.onRowSelectionChange
            },
            response : {
                isValid : false,
                isInValid:false,
                message : ''
            }
        }
    }

    onRowSelectionChange(currentRowsSelected){
        this.setState({
            ...this.state,
            selected_user:this.state.data[currentRowsSelected[0].dataIndex].id,
            response:{
                isInvalid:false,
                isValid:false
            }
        })
    }
    onRowClick(rowData, rowMeta){
        let user_id = this.state.data[rowMeta.dataIndex].id;
        this.props.history.push("/profile/"+user_id);
    }
    componentDidMount(){
        this.fetch_users();
    }


    fetch_users(){
        axiosInstance.get('/users/hierarchy')
        .then(response=>this.on_fetch_users(response.data.data))
        .catch(err => {
            if(err.response.status === 401){
                logOut(this.props);
            }
        })
    }

    on_fetch_users(data){
        var users_data = [];
        data.forEach(element => {
            users_data.push({
                "id" : element.id,
                "username" : element.username,
                "role": element.role.display_name
            })
        });
        this.setState({
            data:users_data
        });
    }
    toolbarSelect(){
        return (
            <ButtonToolbar> 
                    <ButtonGroup  className="mr-2">
                        <Button className = "btn-warning"  onClick = {(e)=>this.update_btn_clicked()}>შეცვლა</Button>
                    </ButtonGroup>
                    <ButtonGroup className="mr-2">
                        <Button className = "btn-danger"  onClick = {(e)=>this.delete_btn_clicked()}>წაშლა</Button>
                    </ButtonGroup>
            </ButtonToolbar>
        )
    }
    update_btn_clicked(){
        this.props.history.push("/users/update_user/"+this.state.selected_user)
    }
    delete_btn_clicked(){
        axiosInstance.delete('/users/'+this.state.selected_user)
        .then(response=>{
            this.setState({
                ...this.state,
                response:{
                    isValid:true,
                    message:response.data.message
                },
                options:{
                    ...this.state.options,
                    rowsSelected:[]
                }
            })
            this.fetch_users();
        })
        .catch(error => {
            if(error.response.status == 422 ||error.response.status==503){
                this.on_bad_request(error);
            }
        });
    }   

    onRowsDelete(rowsDeleted){
        let id = this.state.data[rowsDeleted.data[0].dataIndex].id
        axiosInstance.delete('/users/'+id)
        .then(response=>{
            this.fetch_users();
        })
        .catch(error => {
            if(error.response.status == 400){
                this.on_bad_request(error.response.data);
            }
        });
        return true;
    }

    on_users_deleted(data){
        this.fetch_users();
    }

    on_bad_request(data){
        this.setState({
            response:{
                ...this.state.response,
                isInValid:true,
                message:data.messages
            }
        })
    }

    render(){

        let add_user = null;
        if(containsPermission(this.props.role_permissions,'users.add')){
            add_user = <Link  to = "/users/new_user"  id = "create_new_btn" className="btn btn-dark" > ახლის დამატება</Link>;
        }
        return (
            <div className = "content-main">
                <Form.Row>
                        <Form.Group as={Col}  md="4" >
                            <Form.Control
                                    problem="text"
                                    name="problem"
                                    hidden = {true}
                                    isInvalid = {Boolean(this.state.response.isInValid)}
                                    isValid = {Boolean(this.state.response.isValid)}
                                    onChange = {null}
                                />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.response.message}
                            </Form.Control.Feedback>

                            <Form.Control.Feedback >
                                {this.state.response.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                </Form.Row>
                {add_user}
                <MUIDataTable
                    data={this.state.data}
                    columns={columns}
                    options={this.state.options}
                />
            </div>
        )
    }
}
export default withRouter(Users);